import { UsersAPI, SensorsAPI, LocationsAPI } from '../../lib/api';
import { auth } from '../../lib/auth';
import { normalizeError } from '../../lib/helpers';

export const PAGE = 'PAGE';
export const PAGE_SUCCESS = 'PAGE_SUCCESS';
export const PAGE_ERROR = 'PAGE_ERROR';
export const PAGE_FETCH = 'PAGE_FETCH';
export const PAGE_META = 'PAGE_META';
export const PAGE_FILTER = 'PAGE_FILTER';
export const PAGE_DATA_PART = 'PAGE_DATA_PART';
export const PAGE_DATA_ACTION_START = 'PAGE_DATA_ACTION_START';
export const PAGE_DATA_ACTION_SUCCESS = 'PAGE_DATA_ACTION_SUCCESS';
export const PAGE_DATA_ACTION_FAILURE = 'PAGE_DATA_ACTION_FAILURE';

const API = {
  users: new UsersAPI(),
  sensors: new SensorsAPI(),
  locations: new LocationsAPI(),
};

const actionStart = (params, dataType) => ({
  type: PAGE_DATA_ACTION_START,
  dataType,
});

const actionSuccess = (params, data, dataType) => ({
  type: PAGE_DATA_ACTION_SUCCESS,
  dataType,
  data,
});

const actionFailure = (params, error, dataType) => ({
  type: PAGE_DATA_ACTION_SUCCESS,
  dataType,
  error,
});

export const updateMeta = meta => ({
  type: PAGE_META,
  meta,
});

export const fetchSensors = (orgId, pageMeta) => {
  const personId = auth.person_id;

  return (dispatch, getState) => {
    dispatch({ type: PAGE_FETCH });
    if (!pageMeta) {
      const state = getState();
      pageMeta = state.page.meta || {};
    }

    const promises = [
      API.sensors.list(orgId, personId)
        .then(({ data: { data = [] } }) => dispatch({
          type: PAGE_DATA_PART,
          part: 'sensors',
          data,
        })),
      API.locations.list(orgId).then(({ data }) => {
        dispatch({
          type: PAGE_DATA_PART,
          part: 'locations',
          data,
        });
      }),
    ];

    Promise.all(promises).then((responses) => {
      dispatch({ type: PAGE_SUCCESS, responses });
    }).catch((error) => {
      dispatch({ type: PAGE_ERROR, error });
    });
  };
};

export const deleteSensor = (orgId, sensorId) => {
  const personId = auth.person_id;
  const params = { orgId, sensorId };

  return (dispatch) => {
    dispatch(actionStart(params, 'sensor'));

    API.sensors.delete(orgId, personId, sensorId).then(
      (data) => {
        // Tell the detail view about our great success
        dispatch(actionSuccess(params, data, 'sensor'));
        // Re-fetch sensors if pages are displaying them
        dispatch(fetchSensors(orgId));
      },
      (error) => {
        const normalizedError = normalizeError(error, { prependMessage: 'This sensor could not be deleted:' });
        dispatch(actionFailure(params, normalizedError, 'sensor'));
      }
    );
  };
};



// WEBPACK FOOTER //
// ./src/redux/actions/Page.js